"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ProgressStep", {
  enumerable: true,
  get: function () {
    return _progressStep.default;
  }
});
exports.default = ProgressSteps;
var _reactComponentValidator = _interopRequireDefault(require("react-component-validator"));
var _progressStep = _interopRequireDefault(require("./progress-step"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
const STATUS = _progressStep.default.Status;

/**
 * Helper function that decides ProgressStep component statuses.
 *
 * @param {number} idx Step id
 * @param {number} value Current value of ProgressStep
 * @returns {String} ProgressStep status
 */
function getStepStatus(idx, value) {
  let status = STATUS.Incomplete;
  if (idx < value) {
    status = STATUS.Complete;
  } else if (idx === value) {
    status = STATUS.Current;
  }
  return status;
}

/**
 * Helper function that computes ProgressStep components to be rendered in ProgressSteps.
 *
 * @param {Object} props Props
 * @param {[String]} steps ProgressStep names
 * @param {number} value Current value of ProgressStep
 * @param {[React.Component]} children Components to be displayed beneath the ProgressSteps component
 * @param {number} tabIndex Starting index for ProgressStep components
 * @returns {[ReactElement]} ProgressStep elements
 */
function getStepElements(_ref) {
  let {
    steps,
    value,
    children,
    tabIndex
  } = _ref;
  const stepElements = [];
  if (steps) {
    stepElements.push(...steps.map((name, i) => {
      const idx = i + 1;
      return /*#__PURE__*/_react.default.createElement(_progressStep.default, {
        key: idx,
        tabIndex: tabIndex,
        status: getStepStatus(idx, value)
      }, name);
    }));
  }
  if (children) {
    const offset = stepElements.length + 1;
    stepElements.push(...children.map((step, i) => {
      const idx = i + offset;
      return /*#__PURE__*/_react.default.cloneElement(step, {
        key: idx,
        tabIndex: tabIndex,
        status: getStepStatus(idx, value)
      });
    }));
  }
  return stepElements;
}

/**
 * ProgressSteps component, representing a series of ProgressStep elements.
 *
 * @param {Object} props Props
 * @returns {ReactElement} ReactElement
 */
function ProgressSteps() {
  let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("ul", {
    className: "ux-tabs-wiz-list"
  }, getStepElements(props)));
}
ProgressSteps.Step = _progressStep.default;
ProgressSteps.propTypes = {
  /** Names of each step */
  steps: _propTypes.default.array,
  /** Current value of each step */
  value: _propTypes.default.number,
  /** Child React.Components to be displayed underneath */
  children: (0, _reactComponentValidator.default)([_progressStep.default]),
  /** Developer indicates tabIndex */
  tabIndex: _propTypes.default.oneOf([-1, 0])
};
ProgressSteps.defaultProps = {
  value: 1
};